<template>
	<div class="kefu-redirect">
		<div class="kefu-box">
			<div class="loading-icon">
				<div class="spinner"></div>
			</div>
			<p class="tips">正在进入客服通道...</p>
			<p class="sub-tips">请稍候</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'kefu-redirect',
	data() {
		return {
			kefuBaseUrl: 'https://tb.53kf.com/code/client/584ed1235c905cdb9d9f1fc40f4032c67/1'
		}
	},
	created() {
		sessionStorage.setItem('skipMobileRedirect', 'true')
		this.initKefuRedirect()
	},
	beforeDestroy() {
		sessionStorage.removeItem('skipMobileRedirect')
	},
	methods: {
		generateUniqueId() {
			const userinfo = this.$store.getters.userinfo
			const login = this.$store.getters.login
			
			if (login && userinfo && userinfo.id) {
				return {
					id: userinfo.id,
					name: userinfo.nickname || userinfo.username || '用户' + userinfo.id
				}
			}
			
			const timestamp = Date.now()
			const random = Math.random().toString(36).substr(2, 9)
			return {
				id: `guest_${timestamp}_${random}`,
				name: '游客'
			}
		},
		buildKefuUrl(user) {
			const params = new URLSearchParams()
			params.append('u_cust_id', user.id)
			params.append('u_cust_name', encodeURIComponent(user.name))
			
			const url = `${this.kefuBaseUrl}?${params.toString()}`
			console.log('客服跳转链接:', url)
			return url
		},
		redirect(url) {
			window.location.href = url
		},
		initKefuRedirect() {
			const user = this.generateUniqueId()
			const url = this.buildKefuUrl(user)
			
			setTimeout(() => {
				this.redirect(url)
			}, 500)
		}
	}
}
</script>

<style scoped>
.kefu-redirect {
	width: 100%;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #ffffff;
}

.kefu-box {
	text-align: center;
	color: #000;
}

.loading-icon {
	margin-bottom: 30px;
}

.spinner {
	width: 60px;
	height: 60px;
	margin: 0 auto;
	border: 4px solid rgba(0, 0, 0, 0.1);
	border-radius: 50%;
	border-top-color: #333;
	animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

.tips {
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 10px;
	color: #333;
}

.sub-tips {
	font-size: 14px;
	color: #666;
}
</style>
